var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67188 17.0312C8.67188 16.2977 9.2665 15.7031 10 15.7031C10.7335 15.7031 11.3281 16.2977 11.3281 17.0312C11.3281 17.7648 10.7335 18.3594 10 18.3594C9.2665 18.3594 8.67188 17.7648 8.67188 17.0312Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67261 2.99973C8.62631 2.21081 9.31743 1.64062 10 1.64062C10.6826 1.64062 11.3737 2.21081 11.3274 2.99973L10.9765 12.4754C10.9727 12.7292 10.8703 12.9717 10.6906 13.1515C10.5074 13.3346 10.259 13.4375 10 13.4375C9.74102 13.4375 9.49263 13.3346 9.30949 13.1515C9.12975 12.9717 9.02732 12.7292 9.02357 12.4754L8.67261 2.99973Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.51a5c8d751be197a940ab2ad7d128e7d.svg";
export { ForwardRef as ReactComponent };